import Unit from '@/domain/model/unit/Unit.ts';

export default class Power extends Unit {
  static ZERO: Power = new Power(0);

  // private! Use Power.fromKwh()
  constructor(kw: number) {
    super(kw);
  }

  static ofMw(mw: number): Power {
    return new Power(1e3 * mw);
  }

  static ofKw(kw: number): Power {
    return new Power(kw);
  }

  static of(energy: number, unitString: string): Power {
    switch (unitString.toLowerCase()) {
      case 'w':
        return Power.ofKw(energy / 1e3);
      case 'kw':
        return Power.ofKw(energy);
      case 'mw':
        return Power.ofMw(energy);
      default:
        throw new Error(`unit ${unitString} is not supported`);
    }
  }

  asKw() {
    return this.getValue();
  }

  asMw(): number {
    return this.getValue() / 1e3;
  }

  format(precision = undefined): number {
    let magnitude: number = {
      kW: 1,
      MW: 1e3,
      GW: 1e6,
      TW: 1e9,
    }[this.getFormattedUnit()];
    const formattedValue: number = Number(this.getValue() / magnitude);
    return precision === undefined
      ? formattedValue
      : Number(formattedValue.toPrecision(precision));
  }

  unit(): 'TW' | 'GW' | 'MW' | 'kW' {
    return this.getFormattedUnit();
  }

  getFormattedUnit(): 'TW' | 'GW' | 'MW' | 'kW' {
    const value = this.getValue();
    if (value >= 10000000000) {
      return 'TW';
    } else if (value >= 10000000) {
      return 'GW';
    } else if (value >= 10000) {
      return 'MW';
    } else {
      return 'kW';
    }
  }

  toString(): string {
    return `${this.format(4)} ${this.getFormattedUnit()}`;
  }
}
